module.exports = __webpack_public_path__ + "img/preview-img.b9b7f600.svg";